export { default } from './AdaptiveHeading';
